import { useCallback } from 'react';

import * as ST from './styled';

export interface IChannelProps {
    link: string,
    title: string,
    image: string,
    inactiveLink: boolean,
    className?: string,
}

const Channel = ({ link, title, image, inactiveLink, className }: IChannelProps) => {

    const onClick = useCallback((e) => {
        e.stopPropagation();
        if (inactiveLink) {
            e.preventDefault();
        }
    }, [inactiveLink]);

    return (
        <ST.ChannelLink
            href={link}
            target='_blank'
            onClick={onClick}
            className={className}
            data-test='channel-link'
        >
            <ST.ChannelImageBox>
                <img src={image} alt='' data-test='channel-logo' />
            </ST.ChannelImageBox>
            <ST.ChannelName data-test='channel-name'>{title}</ST.ChannelName>
        </ST.ChannelLink>
    );
};

export default Channel;
